import React, {useState, useEffect} from "react"
import SrcSetLogoPc from "../../static/images/pc/common/jfeel_logo.svg"
import LogoPc from "../../static/images/pc/common/jfeel_logo.svg"
import SrcSetLogoSp from "../../static/images/pc/common/jfeel_logo.svg"
import LogoSp from "../../static/images/pc/common/jfeel_logo.svg"
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import { Link } from "gatsby"
import Headroom from "react-headroom"
import SpSlideMenu from "./sp-slide-menu"

export default function Header() {
  const [isTop, setIsTop] = useState(true);

  const onScroll = () => {
    const position = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    
    if (position === 0) setIsTop(true);
    else setIsTop(false);
  }

  useEffect(() => {
      document.addEventListener("scroll", onScroll);
      return () => document.removeEventListener("scroll", onScroll);
  });

  return (
    <>
    {/*//////////////////////////////* ↓PCヘッダー * //////////////////////////////*/}
    <Headroom className="header_pc pc_only" id="pcHeader" disable={true}>
      <div className={isTop ? "header_pc_in_transmission" : "header_pc_in"}>
        <div className="w_logo">
          <Link className="logo" to="/"><picture><source type="image/webp" srcSet={SrcSetLogoPc} /><LazyAndPreloadImage imgUrl={LogoPc} alt="J.Feel コーポレートサイト" width="189" height="64" /></picture></Link>
        </div>
        <div className="tagline pc_only">
          ジェイフィールは、<span>良い感情の連鎖を起こすこと</span>で<br/>人と組織の変革を支援するコンサルティング会社です
        </div>
        <div className="navigation-area">
          <div className="nav-button-area">
            <Link to="/note" className="bg_braun">オウンドメディアを見る</Link>
            <Link to="https://ma.j-feel.jp/inquiry.html" className="bg_green" target="_blank" rel="noopener noreferrer">お問い合わせ・ご相談</Link>
          </div>
          <ul className="dropdown-menu">
            <li>
              <Link className="menu-item" to="/philosophy">ジェイフィールの想い</Link>
              <div className="dropdown-content">
               <div className="dd_title">
                <span>Philosophy</span>
                <h4>ジェイフィールの想い</h4>
               </div> 

               <div className="dd_flex">
                <div className="dd_flex_left">
                「人と組織と社会のつながりを再生し、未来へつなぐ」ジェイフィールが大切にする想いをご紹介します。
                </div>
                <div className="dd_flex_right">
                  <Link to="/philosophy#mission_ttl">
                    <div className="dd_btn_item">
                      <p className="dd_btn_title">ミッション</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/philosophy#key_method_ttl">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">キーメソッド</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/philosophy#symbol_ttl">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">ジェイフィールのロゴ</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                </div>
               </div>
              </div>
            </li>
            <li>
              <Link className="menu-item" to="/seminar">セミナーを探す</Link>
              <div className="dropdown-content">
               <div className="dd_title">
                <span>Seminar</span>
                <h4>セミナーを探す</h4>
               </div> 

               <div className="dd_flex">
                <div className="dd_flex_left">
                  組織開発、人材育成のいろんな知見、ノウハウを知り、我々と一緒に探究を深めてみませんか？
                </div>
                <div className="dd_flex_right">
                  <Link to="/seminar">
                    <div className="dd_btn_item">
                      <p className="dd_btn_title">セミナー一覧</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/seminar/archive">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">過去開催したセミナー</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                </div>
               </div>
              </div>
            </li>
            <li><Link className="menu-item arrow"  to="/program">プログラムを探す</Link></li>
            <li>
              <Link className="menu-item" to="/publication">出版書籍・メディア</Link>
              <div className="dropdown-content">
               <div className="dd_title">
                <span>Publication</span>
                <h4>出版書籍・メディア</h4>
               </div> 

               <div className="dd_flex">
                <div className="dd_flex_left">
                  ジェイフィールの組織開発や人材育成に関する書籍と、メディア掲載をご覧ください。
                </div>
                <div className="dd_flex_right">
                  <Link to="/publication/book">
                    <div className="dd_btn_item">
                      <p className="dd_btn_title">出版書籍</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/publication/media">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">メディア掲載</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                </div>
               </div>
              </div>
            </li>
            <li>
              <Link className="menu-item" to="/company">会社紹介</Link>
              <div className="dropdown-content">
               <div className="dd_title">
                <span>Company</span>
                <h4>会社紹介</h4>
               </div> 

               <div className="dd_flex">
                <div className="dd_flex_left">
                  私たちは、講演、研修、ワークショップ、コンサルティングを通じて人と人とのつながりを再生し、人と組織を元気にする活動を展開しています。
                </div>
                <div className="dd_flex_right">
                  <Link to="/company#greeting_ttl">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">ご挨拶</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/company#overview_ttl">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">会社概要</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/company#supporter_ttl">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">サポーターのご紹介</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  <Link to="/recruit">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">採用情報</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link>
                  {/* <Link to="/en/about">
                    <div className="dd_btn_item">
                    <p className="dd_btn_title">For English</p>
                      <div className="round-arrow">
                        <img src="/images/pc/common/arrow.svg" alt="Arrow" className="icon_arrow"/>
                      </div>
                    </div>
                  </Link> */}
                </div>
               </div>
              </div>
            </li>
          </ul>
        </div>
      </div>{/* header_pc_in */}
    </Headroom>{/* header_pc */}
    {/*//////////////////////////////* ↑PCヘッダー * //////////////////////////////*/}
    
    {/*//////////////////////////////* ↓スマホヘッダー * //////////////////////////////*/}
    <div className="header_sp sp_only" id="spHeader">
      <div className="header_sp_in">
        <div className="w_i_cv sp_only">
          <div className="i_nav js_nav_sp_slide"><span className="i_nav-icon" /></div>
        </div>
        <Link className="logo" to="/">
          <picture>
            <source type="image/webp" srcSet={SrcSetLogoSp} />
            <LazyAndPreloadImage imgUrl={LogoSp} alt="J.Feel コーポレートサイト" width="97" height="33" />
          </picture>
        </Link>
        <Link className="sp_mail_link" to="https://ma.j-feel.jp/inquiry.html">お問い合わせ</Link>
      </div>{/* header_sp_in */}
      <SpSlideMenu width={350} />
    </div>{/* header_sp */}
    {/* <div className="header_sp_space" /> */}
    </>
  )
}
